import '../modernizr';
import MobileDetect from 'mobile-detect';

import * as eases from 'eases';

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularSanitize from 'angular-sanitize';
import angularAnimate from 'angular-animate';
import angularTouch from 'angular-touch';

import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';

import angularLoadingBar from 'angular-loading-bar';
import angularGsapifyRouter from 'angular-gsapify-router';
import angularScroll from 'angular-scroll';
import angularImagesLoaded from 'angular-images-loaded';
import angularColumnify from 'angular-columnify';
import angularGridflex from 'angular-gridflex';
import angularMediaEvents from 'angular-media-events';

import * as ScrollWizardry from 'scrollwizardry';
import angularScrollMagic from 'angular-scroll-magic';

import * as ace from '@homerjam/ace-angular';

var md = new MobileDetect(window.navigator.userAgent);

window.Modernizr.addTest({
  mobile: !!md.mobile(),
  tablet: !!md.tablet(),
  desktop: !md.mobile() && !md.tablet(),
});

window.MobileDetect = md;

const pushStateSupported = !!(window.history && window.history.pushState);

if (!pushStateSupported && window.location.pathname !== '/') {
  window.location.href = `/#${window.location.pathname}`;
}

window.ScrollWizardry = ScrollWizardry;

angular
  .module('app', [
    uiRouter,
    angularSanitize,
    angularAnimate,
    angularTouch,

    Common.name,
    Components.name,

    ace.apiService,
    ace.errorService,
    ace.helperService,
    ace.generalFilters,

    angularLoadingBar,
    angularGsapifyRouter,
    angularScroll,
    angularImagesLoaded,
    angularColumnify,
    angularGridflex,
    angularScrollMagic,
    angularMediaEvents,
  ])

  .constant('appConfig', window.appConfig)

  .value('duScrollEasing', eases.quintInOut)
  .value('duScrollDuration', 800)

  .directive('app', AppComponent)

  .config(
    (
      $compileProvider,
      $stateProvider,
      $locationProvider,
      $urlRouterProvider,
      $urlMatcherFactoryProvider,
      $sceDelegateProvider,
      cfpLoadingBarProvider,
      gsapifyRouterProvider
      // scrollMagicProvider
    ) => {
      'ngInject';

      $compileProvider.debugInfoEnabled(false);

      $locationProvider.html5Mode(pushStateSupported);
      $urlRouterProvider.otherwise('/404');
      $urlMatcherFactoryProvider.strictMode(false);

      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://*.s3.amazonaws.com/**',
        'https://*.youtube.com/**',
        'http://*.youtube.com/**',
        'https://*.vimeo.com/**',
        'http://*.vimeo.com/**',
        'https://*.embedly.com/**',
        'http://*.darling-creative.com/**',
      ]);

      // scrollMagicProvider.addIndicators = true;

      // cfpLoadingBarProvider.includeBar = false;
      cfpLoadingBarProvider.includeSpinner = false;

      gsapifyRouterProvider.defaults = {
        enter: 'fadeDelayed',
        leave: 'fade',
      };

      let fade = {
        duration: 0.4,
        css: {
          opacity: 0,
        },
      };

      // let upDelayed = {
      //   duration: 0.6,
      //   delay: 0.6,
      //   ease: 'Power4.easeOut',
      //   css: {
      //     y: '100%',
      //   },
      // };

      let fadeDelayed = {
        duration: 0.4,
        delay: 0.6,
        css: {
          opacity: 0,
        },
      };

      gsapifyRouterProvider.transition('fade', fade);
      gsapifyRouterProvider.transition('fadeDelayed', fadeDelayed);

      $stateProvider.state('index', {
        abstract: true,
        resolve: {
          metadata: ($rootScope, ApiService) =>
            ApiService.metadata().then((metadata) => {
              $rootScope.metadata = metadata;
              $rootScope.pageDescription = metadata.description;
              return metadata;
            }),
          contact: (ApiService) =>
            ApiService.entitySearchOne({
              q: 'schema:contact',
              include_docs: true,
            }),
        },
        views: {
          app: {
            component: 'app',
          },
          'menu@index': {
            component: 'menu',
          },
        },
      });
    }
  )

  .run(
    (
      $rootScope,
      $state,
      $location,
      $window,
      $document,
      $timeout,
      $log,
      $transitions,
      HelperService,
      appConfig
    ) => {
      'ngInject';

      $rootScope.slug = appConfig.slug;
      $rootScope.assistUrl = appConfig.assistUrl;

      $rootScope.$state = $state;
      $rootScope.$location = $location;

      $rootScope.$isMobile = !!md.mobile();
      $rootScope.$isTablet = !!md.tablet();
      $rootScope.$isDesktop = !md.mobile() && !md.tablet();

      $rootScope.now = new Date();

      // Error catching

      $transitions.onError({}, (transition) => {
        $log.error(transition.error());

        if (transition.to().name !== 'index.home') {
          $state.go('index.home');
        }
      });

      // Google Analytics

      $transitions.onSuccess({}, () => {
        if (typeof ga !== 'undefined') {
          window.ga('send', 'pageview', {
            page: $location.path(),
          });
        }
      });

      // Ready

      $transitions.onSuccess({}, () => {
        if (!$rootScope.$isReady) {
          $timeout(() => {
            $rootScope.$isReady = true;
          });
        }
      });

      // Force repaint to correct page height

      // $rootScope.$on('gsapifyRouter:enterSuccess', function (event, element) {
      //   let view = element.attr('ui-view');

      //   if (view === 'content') {
      //     let el = $document[0].body;
      //     let display = el.style.display;
      //     el.style.display = 'none';
      //     let trick = el.offsetHeight;
      //     el.style.display = display;

      //     $timeout(() => {
      //       element.addClass('enter-success');
      //     });
      //   }
      // });

      // Loading

      $rootScope.$on('cfpLoadingBar:started', () => {
        $rootScope.$loading = true;
      });

      $rootScope.$on('cfpLoadingBar:completed', () => {
        $rootScope.$loading = false;
      });

      // Pinterest

      $timeout(() => {
        $rootScope.pinterestEnable = true;
      }, 1000);

      // Social images
      // const base = [$location.protocol(), '://', $location.host(), ':', $location.port()].join('');
      const base = '';

      $rootScope.socialImage = (url) => {
        $rootScope.ogImage = base + url;
        $rootScope.twitterImage = base + url;
      };
    }
  );
